import { FC } from 'react';
import { ConditionalWrapper } from 'components/Shared/ConditionalWrapper';
import * as Styled from './styles';
import { useAppSelector } from 'appRedux/hooks';
import placeholderImage from 'assets/images/user-image.png';
import { TSizeType } from 'interfaces';

type TerminalAccountBoxProps = {
  size?: TSizeType;
  fixedPosition?: boolean;
};

enum EAvatarSize {
  small = 48,
  medium = 56,
  large = 64,
  huge = 80
}

export const TerminalAccountBox: FC<TerminalAccountBoxProps> = ({
  size = 'huge',
  fixedPosition = false
}) => {
  const { data: userData } = useAppSelector(({ user }) => user);

  if (!userData) {
    return null;
  }

  return (
    <ConditionalWrapper
      condition={fixedPosition}
      wrapper={children => (
        <Styled.TerminalAccountFixedContainer>
          {children}
        </Styled.TerminalAccountFixedContainer>
      )}
    >
      <Styled.TerminalAccountWrapper
        className="x-terminal-account-wrapper"
        $size={size}
      >
        <Styled.TerminalAccountAvatarWrapper>
          <Styled.TerminalAccountUserAvatar
            size={EAvatarSize[size]}
            src={placeholderImage} // TODO: no logo on user data
          />
        </Styled.TerminalAccountAvatarWrapper>
        <Styled.TerminalAccountUserInfo>
          <Styled.TerminalAccountUserName>
            {userData.name}
          </Styled.TerminalAccountUserName>
        </Styled.TerminalAccountUserInfo>
      </Styled.TerminalAccountWrapper>
    </ConditionalWrapper>
  );
};
